// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkflowDiagramStagesInner } from './workflow-diagram-stages-inner';
import {
    WorkflowDiagramStagesInnerFromJSON,
    WorkflowDiagramStagesInnerFromJSONTyped,
    WorkflowDiagramStagesInnerToJSON,
    WorkflowDiagramStagesInnerToJSONTyped,
} from './workflow-diagram-stages-inner';

/**
 * 
 * @export
 * @interface WorkflowDiagram
 */
export interface WorkflowDiagram {
    /**
     * 
     * @type {string}
     * @memberof WorkflowDiagram
     */
    current_stage: string;
    /**
     * 
     * @type {number}
     * @memberof WorkflowDiagram
     */
    progress_percentage: number;
    /**
     * 
     * @type {Array<WorkflowDiagramStagesInner>}
     * @memberof WorkflowDiagram
     */
    stages: Array<WorkflowDiagramStagesInner>;
}

/**
 * Check if a given object implements the WorkflowDiagram interface.
 */
export function instanceOfWorkflowDiagram(value: object): value is WorkflowDiagram {
    if (!('current_stage' in value) || value['current_stage'] === undefined) return false;
    if (!('progress_percentage' in value) || value['progress_percentage'] === undefined) return false;
    if (!('stages' in value) || value['stages'] === undefined) return false;
    return true;
}

export function WorkflowDiagramFromJSON(json: any): WorkflowDiagram {
    return WorkflowDiagramFromJSONTyped(json, false);
}

export function WorkflowDiagramFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowDiagram {
    if (json == null) {
        return json;
    }
    return {
        
        'current_stage': json['current_stage'],
        'progress_percentage': json['progress_percentage'],
        'stages': ((json['stages'] as Array<any>).map(WorkflowDiagramStagesInnerFromJSON)),
    };
}

export function WorkflowDiagramToJSON(json: any): WorkflowDiagram {
    return WorkflowDiagramToJSONTyped(json, false);
}

export function WorkflowDiagramToJSONTyped(value?: WorkflowDiagram | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'current_stage': value['current_stage'],
        'progress_percentage': value['progress_percentage'],
        'stages': ((value['stages'] as Array<any>).map(WorkflowDiagramStagesInnerToJSON)),
    };
}
